'use client';

import { useEffect } from 'react';
import Image from 'next/image';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showLuna?: boolean;
}

export default function ModalWrapper({ isOpen, onClose, children, showLuna = true }: ModalWrapperProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className='animate-fadeIn fixed inset-0 z-50 bg-black/80 backdrop-blur-sm'
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>{children}</div>
    </>
  );
}
